import React, { useEffect, useState, useCallback } from 'react';
import {
    IonContent,
    IonPage,
    IonIcon, useIonAlert,
} from '@ionic/react';
import {
    addCircle, addOutline,
    chevronBack,
    chevronForward, download, downloadOutline, eye, pencil, trash,
} from 'ionicons/icons';
import useStore from "../../zustand/useStore";
import {
    actionToApproveAssignmentPortalPost,
    actionToDeleteAssignmentPostData,
    actionToGetRfpAdminAssignmentDataByFilter
} from "../../apiHelpers/CommonAction";
import {FacebookLoader} from "../../components/Loader/FacebookLoader";
import moment from "moment-timezone";
import AssignmentsDetailSheetPopup from "../../components/AssignmentsDetailSheetPopup";
import RaiseRFPModal from "../../components/RaiseRFPModal";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const ITEMS_PER_PAGE = 10;

const AdminAssignmentsPage = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const {rfpAssignmentDataState} = useStore();
    const {loading,assignments ,totalCount} = rfpAssignmentDataState;
    const pageCount = Math.ceil((totalCount || 0) / ITEMS_PER_PAGE);
    const [assignmentDetail, setAssignmentDetail] = useState({});
    const [isDetailOpen, setIsDetailOpen] = useState(false);
    const [showRaiseRFP, setShowRaiseRFP] = useState(false);
    const [assignmentType, setAssignmentType] = useState('');
    const [dataForEditing, setDataForEditing] = useState({});
    const [presentAlert] = useIonAlert();

    const callFunctionToDeletedata = (id)=>{
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to delete this item.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Delete', role: 'confirm', handler: async () =>{
                        await actionToDeleteAssignmentPostData(id)
                    }},
            ],
        });
    }

    const openJobDetailPanel = (jobDetail)=>{
        setAssignmentDetail(jobDetail);
        setIsDetailOpen(true);
    }

    const fetchPageData = useCallback((page) => {
        const newOffset = (page - 1) * ITEMS_PER_PAGE;
        setCurrentPage(page);
        actionToGetRfpAdminAssignmentDataByFilter(false, { offset: newOffset,retainership:assignmentType });
    }, [assignmentType]);

    useEffect(() => {
        fetchPageData(1);
    }, [fetchPageData]);

    const handlePrev = () => {
        if (currentPage > 1) {
            fetchPageData(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < pageCount) {
            fetchPageData(currentPage + 1);
        }
    };

    const callFunctionToSetEditData = (data)=>{
        setDataForEditing(data);
        setShowRaiseRFP(true);
    }


    const callFunctionToSetAddModalSheet = ()=>{
        setDataForEditing(null);
        setShowRaiseRFP(true);
    }

    const callFunctionToApproveAssignmentPost = (assignment)=>{
        let payload = {
            object_id: assignment.id,
            object_name: 'assignments',
            user_id: assignment.created_by,
            is_created_for_admin: 0,
            id: assignment.id,
            message: `Your assignment "${assignment.title}" has been approved by Admin.`
        }
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to approve this assignment post.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Approve', role: 'confirm', handler: async () =>{
                        await actionToApproveAssignmentPortalPost(payload);
                        fetchPageData(currentPage);
                    }},
            ],
        });
    }


    const downloadExcel = () =>{
        // 1. Map only the fields you want in Excel
        const formattedData = assignments.map(item => ({
            ID: item.id,
            Title: item.title,
            Location: item.location,
            'Expiry Date': item.expiry_date,
            Price: item.price,
            'Scope Of Work': item.scope_of_work,
            Retainership: item.retainership,
            PDF: item.attched_pdf_url,
            Email: item.email,
            'Created At': item.created_at,
            'Created By': item.created_by,
            Approved: item.is_approved ? "Yes" : "No",
            Name: item.name,
            'Phone Number': item.phone_number,
        }));

        // 2. Convert JSON to worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // 3. Create a workbook and append worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "RFPs");

        // 4. Generate Excel file and trigger download
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, "assignments.xlsx");
    }


    return (
        <IonPage>
            <IonContent className="ion-padding news-letter-content-page">
                <div className="admin_inner_tab_container">
                    <div className="header-row">
                        <div className={"d-flex ion-align-items-center w-full"}>
                            <h2 className="newsletter-heading">All Assignments</h2>
                            <div className={"d-flex newsletter-heading_right ion-align-items-center ml-auto"}>
                                <IonIcon
                                    className="add_news_icon addnews-btn job-portal"
                                    onClick={() => callFunctionToSetAddModalSheet()}
                                    icon={addOutline}
                                />



                                {assignments?.length > 0 ? (
                                    /*<IonIcon
                                        className="add_news_icon"
                                        onClick={() => downloadExcel()}
                                        icon={download}
                                    /> */

                                    <button className="download-button" onClick={() => downloadExcel()}>
                                        <IonIcon size={1} icon={downloadOutline}  />
                                        <span>Download</span>
                                    </button>

                                ) :""}
                                <div className="filters-row admin_datatable_filter">
                                    <div className="admin-employee-filter filters-row ml-2">
                                        {/* Month Filter */}
                                        <select
                                            className={"pl-2"}
                                            value={assignmentType}
                                            onChange={(e) => setAssignmentType(e.target.value)}>
                                            <option value={''}>All</option>
                                            <option value={'Retainership'}>Retainership</option>
                                            <option value={'Assignment'}>Assignment</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="newsletter-table-container">

                        <table className="newsletter-table">
                            <thead>
                            <tr>
                                <th>Title</th>
                                <th>Category</th>
                                <th>Email</th>
                                <th>Name</th>
                                <th>Phone No</th>
                                <th>Location</th>
                                <th>Days Left</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {(loading) ?
                                <>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                </>
                                :(assignments?.length > 0) ? (
                                    assignments.map((item) => (
                                        <tr key={item.id}>
                                            <td>
                                                {item.title}
                                            </td>
                                            <td>{item.retainership}</td>
                                            <td>{item.email}</td>
                                            <td>{item.name}</td>
                                            <td>{item.phone_number}</td>
                                            <td>{item.location}</td>
                                            <td>{
                                                (() => {
                                                    const daysLeft = moment(item.expiry_date).startOf('day').diff(moment().startOf('day'), 'days');
                                                    return daysLeft < 0
                                                        ? 'Expired'
                                                        : `${daysLeft} Day${daysLeft !== 1 ? 's' : ''} Left`;
                                                })()
                                            }</td>
                                            <td>
                                                {(!item?.is_approved) ?
                                                    <div
                                                        onClick={() => callFunctionToApproveAssignmentPost(item)}
                                                        className="filter_sheet_clear_all_btn not-approve">
                                                        Not Approved
                                                    </div>
                                                    :
                                                    <div className="filter_sheet_clear_all_btn approved">
                                                        Approved
                                                    </div>}
                                            </td>
                                            <td className={"action_td"}>
                                                <IonIcon icon={eye} onClick={()=>openJobDetailPanel(item)} className={"admin_delete_button_icon eye_icon"}/>
                                                <IonIcon icon={pencil} onClick={()=>callFunctionToSetEditData(item)} className={"admin_delete_button_icon pencil_icon"}/>
                                                <IonIcon icon={trash} onClick={()=>callFunctionToDeletedata(item?.id)} className={"admin_delete_button_icon"}/>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" style={{ textAlign: 'center', padding: '1rem' }}>
                                            No assignments found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="pagination-controls">
                        <button
                            type="button"
                            className={"pagination_button"}
                            disabled={currentPage === 1}
                            onClick={handlePrev}
                        >
                            <IonIcon icon={chevronBack} />
                        </button>
                        <span className="page-info">
                            Page {currentPage} of {pageCount}
                        </span>
                        <button
                            type="button"
                            className={"pagination_button"}
                            disabled={currentPage === pageCount}
                            onClick={handleNext}
                        >
                            <IonIcon icon={chevronForward} />
                        </button>
                    </div>
                </div>
            </IonContent>

            {(isDetailOpen) ?
            <AssignmentsDetailSheetPopup
                isOpen={isDetailOpen}
                onDidDismiss={() => setIsDetailOpen(false)}
                assignmentDetail={assignmentDetail}/>:''
            }
            {(showRaiseRFP) ?
                <RaiseRFPModal isOpen={showRaiseRFP} fromAdminList={true} dataForEditing={dataForEditing} onDismiss={() => setShowRaiseRFP(false)}/>
                :''
            }
        </IonPage>
    );
};

export default AdminAssignmentsPage;
